import { SubscriptionTier } from "../proto/api_pb";

export const isBillingRequired = (
  subscriptionTier: number,
  storageUsage: number
): boolean => {
  const proUserOverStorageLimit =
    subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_PRO &&
    storageUsage >= 100;
  const minorUserOverStorageLimit =
    subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_MINOR &&
    storageUsage >= 500;
  const majorUserOverStorageLimit =
    subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_MAJOR &&
    storageUsage >= 1000;
  const studioUserOverStorageLimit =
    subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_STUDIO &&
    storageUsage >= 1000;
  const freeUserOverStorageLimit =
    (subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED ||
      subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_FREE) &&
    storageUsage >= 5;
  if (
    proUserOverStorageLimit ||
    freeUserOverStorageLimit ||
    minorUserOverStorageLimit ||
    majorUserOverStorageLimit ||
    studioUserOverStorageLimit
  ) {
    return true;
  } else {
    return false;
  }
};
